export async function retryAsync(times, backoffMs, fn) {
	let error;
	let nextFalloff = backoffMs;
	for (let x = 0; x < times; x++) {
		let p;
		if (x !== 0 && backoffMs > 0) {
			p = new Promise((resolve, reject) => {
				setTimeout(() => {
					nextFalloff *= 2;
					resolve();
				}, nextFalloff);
			});
		}

		if (p) await p;
		try {
			return await fn();
		} catch (err) {
			error = err;
			if (err.name === "AbortError") {
				break;
			}
		}
	}

	throw error;
}
